(function () {
  if (window.__teaQuizConstitutionOrchestratorV1) return;
  window.__teaQuizConstitutionOrchestratorV1 = 1;
  /* Deprecated: constitution hub is handled by quiz-constitution-live-fix-v11.js */
})();
